import Tags, { TAGS } from './Tags';

export { Tags, TAGS };
